import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";

function VerticalMenu() {
  const { file, setFile } = useContext(AppContext);

  return (
    <>
      <div className="panel vertical">
        <button
          className={
            file.currentView === "partView" ? "primary-button" : "accent-button"
          }
          onClick={() => {
            setFile({ ...file, currentView: "partView" });
          }}
        >
          Part
        </button>
        <button
          className={
            file.currentView === "supportsView"
              ? "primary-button"
              : "accent-button"
          }
          onClick={() => {
            setFile({ ...file, currentView: "supportsView" });
          }}
        >
          Supports
        </button>
        <button
          className={
            file.currentView === "simulationView"
              ? "primary-button"
              : "accent-button"
          }
          onClick={() => {
            setFile({ ...file, currentView: "simulationView" });
          }}
        >
          Simulation
        </button>
      </div>
    </>
  );
}

export default VerticalMenu;
